
import { TestDetails as TestDetailsType } from "@/hooks/useTestCreator";
import { BasicTestInfo } from "./BasicTestInfo";
import { JobInfo } from "./JobInfo";
import { RichTextEditor } from "./RichTextEditor";
import { Label } from "@/components/ui/label";
import { FileText } from "lucide-react";

interface TestDetailsProps {
  details: TestDetailsType;
  onChange: (details: TestDetailsType) => void;
}

export const TestDetails = ({ details, onChange }: TestDetailsProps) => {
  const handleRichTextChange = (content: string) => {
    onChange({ 
      ...details, 
      description: content,
      // Clear the keyResponsibilities since we're now using merged content
      keyResponsibilities: "" 
    });
  };

  // Merge description and keyResponsibilities for initial value if both exist
  const mergedContent = details.description.includes(details.keyResponsibilities) 
    ? details.description 
    : details.keyResponsibilities 
      ? `${details.description || ""}\n\n${details.keyResponsibilities || ""}`
      : details.description;

  return (
    <div className="space-y-8 bg-card p-8 rounded-lg border border-border shadow-sm text-card-foreground">
      <BasicTestInfo details={details} onChange={onChange} />
      <JobInfo details={details} onChange={onChange} />
      
      <div className="space-y-2">
        <Label htmlFor="merged-description" className="flex items-center gap-2">
          <FileText className="h-4 w-4" />
          Role Description
        </Label>
        <RichTextEditor
          value={mergedContent}
          onChange={handleRichTextChange}
          placeholder="Enter the complete role description including responsibilities..."
        />
      </div>
    </div>
  );
};
